import { msalInstance } from '../providers/msalProvider';

/**
 * Checks if the current user has a specific claim
 * @param claimType The claim type to check (e.g., 'roles', 'groups')
 * @param claimValue The claim value to check for
 * @returns True if the user has the claim, false otherwise
 */
export function hasUserClaim(claimType: string, claimValue: string): boolean {
    try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
            return false;
        }

        const account = accounts[0];
        const claims = account.idTokenClaims as Record<string, unknown>;
        
        if (!claims || !claims[claimType]) {
            return false;
        }

        const claimValues = claims[claimType];

        // Handle both string and array of strings
        if (Array.isArray(claimValues)) {
            return claimValues.includes(claimValue);
        }
        
        return claimValues === claimValue;
    } catch (error) {
        console.error('Error checking user claim:', error);
        return false;
    }
}


/**
 * Checks if the current user has the DIGTX-Storage-Container-Creator role
 * @returns True if the user is a storage manager, false otherwise
 */
export function isContainerCreator(): boolean {
    return hasUserClaim('roles', 'DIGTX-Storage-Container-Creator');
}
